//#region src/storage/storage-key.ts
var e = {
	CommonPrefix: "sio_",
	SessionStorePrefix: "sio_session_"
};
//#endregion
export { e as StorageKey };
